module.exports = __webpack_public_path__ + "static/media/logo_colour_no_border.4ade8894.svg";